<template>
    <menubar />
    <div class="container">
      <!-- タイトルdivタグ -->
      <div class="title-btn d-flex justify-content-between align-items-center">
        <div id="title" class="d-flex justify-content-start">
          <img src="/img/05_slash.svg" />
          <p class="h1">クライアント詳細</p>
        </div>
      </div>
      <!-- 表全体を囲うdivタグ -->
      <div class="usersetting">

        <!-- 基本情報 -->
        <div class="sub-title d-flex justify-content-between align-items-center">
          <p class="h3"><b>基本情報</b></p>
          <!--<a class="btn btn-purple" :href="route('clients.edit',{client: client.id, type: 'common'})">変更</a>-->
          <Link class="btn btn-purple" :href="route('clients.edit', {client: client.id, type: 'common'})">変更</Link>
        </div>
        <table class="table infromation-table">
          <tbody>
            <tr>
              <th class="infromation-table__th">
                <div class="col table-header">
                  クライアント名
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{client.name}}
                </div>
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="col table-header">
                  カテゴリー
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{client.category}} <br>
                </div>
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="col table-header">
                  事業部・組織名など
                  <div>
                    ( フリガナ )
                  </div>
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{client.organization_name}} <br>
                </div>
                <div class="table-data">
                  ( {{client.organization_kana}} )
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- 契約者 -->
        <div class="sub-title d-flex justify-content-between align-items-center">
          <p class="h3"><b>契約者<span class="h5">（請求書送付先）</span></b></p>
          <!--<a class="btn btn-purple" :href="route('clients.edit',{client: client.id, type: 'contractor'})">変更</a>-->
          <Link class="btn btn-purple" :href="route('clients.edit', {client: client.id, type: 'contractor'})" aria-label="契約者情報を変更">変更</Link>
        </div>
        <table class="table infromation-table">
          <tbody>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  氏名
                  <div>
                    ( フリガナ )
                  </div>
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{client.contractor_name}} <br>
                </div>
                <div class="table-data">
                  ( {{client.contractor_kana}} )
                </div>
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  部署名など
                  <div>
                    ( フリガナ )
                  </div>
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{client.division_name}} <br>
                </div>
                <div class="table-data">
                  ( {{client.division_kana}} )
                </div>
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  役職名など
                  <div>
                    ( フリガナ )
                  </div>
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{client.contractor_position_name}} <br>
                </div>
                <div class="table-data">
                  ( {{client.contractor_position_kana}} )
                </div>
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  住所
                  <div>
                    ( フリガナ )
                  </div>
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{client.address_name}} <br>
                </div>
                <div class="table-data">
                  ( {{client.address_kana}} )
                </div>
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  電話番号
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{client.contractor_phone_number}}
                </div>
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  メールアドレス
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{client.contractor_email}}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- オーナー -->
        <div class="sub-title d-flex justify-content-between align-items-center">
          <p class="h3"><b>オーナー</b></p>
          <Link class="btn btn-purple" :href="route('clients.edit', {client: client.id, type: 'owner'})" aria-label="オーナー情報を変更">変更</Link>
        </div>
        <table class="table infromation-table">
          <tbody>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  登録ユーザー名
                  <!-- <div>
                    ( フリガナ )
                  </div> -->
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data" >
                  {{OwnerName()}} <br>
                </div>
                <!-- <div class="table-data" >
                  ( {{OwnerNameKana()}} )
                </div> -->
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  メールアドレス
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{OwnerEmail()}}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- 契約状況 -->
        <div class="sub-title d-flex justify-content-between align-items-center">
          <p class="h3"><b>契約状況</b></p>
          <!--<a class="btn btn-purple" :href="route('clients.edit',{client: client.id, type: 'contract'})">変更</a>-->
          <Link class="btn btn-purple" :href="route('clients.edit', {client: client.id, type: 'contract'})">変更</Link>
        </div>
        <table class="table infromation-table">
          <tbody>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  ステータス
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{ client.status === 0 ? '利用中' : (client.status === -1 ? '利用前' : '停止') }}
                </div>
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  プラン
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{client.client_contract_plan.contract_plan.name}}
                </div>
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  利用開始日
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{new Date(client.client_contract_plan.beginning_date).toLocaleDateString('ja-JP',{ year: 'numeric', month: 'short', day: 'numeric'})}}
                </div>
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  利用停止日
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{new Date(client.client_contract_plan.expiration_date).toLocaleDateString('ja-JP',{ year: 'numeric', month: 'short', day: 'numeric'})}}
                </div>
              </td>
            </tr>
            <tr>
              <th class="infromation-table__th">
                <div class="table-header">
                  利用期限
                </div>
              </th>
              <td class="infromation-table__td">
                <div class="table-data">
                  {{
                    Math.ceil(
                      (new Date(client.client_contract_plan.expiration_date)
                      - new Date(client.client_contract_plan.beginning_date))
                      / (1000 * 60 * 60 * 24)
                    ) + " 日"
                  }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

          <!-- ゆーざーID -->
          <div class="sub-title d-flex justify-content-between align-items-center">
            <p class="h3"><b>ユーザーID</b></p>
          <!--<a class="btn btn-purple" :href="route('clients.edit',{client: client.id, type: 'user_id'})">変更</a>-->
          <Link class="btn btn-purple" :href="route('clients.edit', {client: client.id, type: 'user_id'})">変更</Link>

          </div>
          <table class="table infromation-table">
            <tbody>
              <tr>
                <th class="infromation-table__th">
                  <div class="table-header">
                    発行数 / 上限数
                  </div>
                </th>
                <td class="infromation-table__td">
                  <div class="table-data">
                    <span :class=" client.users.length > client.client_contract_plan.max_number_of_users ? 'text-danger fw-bold'  : '' ">
                      {{client.users.length}} / {{client.client_contract_plan.max_number_of_users}}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- AIモデル -->
          <div class="sub-title d-flex justify-content-between align-items-center">
            <p class="h3"><b>AIモデル</b></p>
          <!-- <a class="btn btn-purple" :href="route('clients.edit',{client: client.id, type: 'ai_model'})">変更</a> -->
          <Link class="btn btn-purple" :href="route('clients.edit', {client: client.id, type: 'ai_model'})">変更</Link>
          </div>
          <table class="table infromation-table">
            <tbody>

              <tr style="width: 100%">
                <th colspan="2" rowspan="1">
                  <div class="table-header"> 契約モデル一覧 </div>
                  <table class="aimodel_table component_table" cellpadding="5">
                    <thead>
                      <tr>
                        <th class="th--aimodel-name">モデル名</th>
                        <th class="th--language-pair">言語ペア</th>
                        <th class="th--description">説明</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="aimodel in client.aimodels" :id="aimodel.id">
                        <td class="td--aimodel-name">{{ aimodel.name }}</td>
                        <td>
                          {{ aimodel.src_language_code }} → {{ aimodel.trg_language_code }}
                        </td>
                        <td 
                          v-bind:class="[showing_aimodel_description_ids.includes(aimodel.id) ? 'td--description' : 'td--description__hidden']" 
                          @click="switchAimodelDescription(aimodel.id)"
                        >
                          {{ aimodel.description }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </th>

                <!--
                  <div v-for="model in client.aimodels" :id="model.id" class="table-data">
                    <div v-if="model.is_trainable==1"><b class="aimodel_name--trainable">{{model.name}}</b> (親モデル)</div>
                    <div v-else>{{model.name}}</div>
                  </div>
                -->
              </tr>

              <tr>
                <th class="infromation-table__th">
                  <div class="table-header">
                    学習データ提供契約
                  </div>
                </th>
                <td class="infromation-table__td">
                  <div class="table-data">
                    {{client.is_allowed_training_data_provision ? "○" : "☓"}}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

        <div class="modal-btn d-flex justify-content-evenly div__button">
        </div>

      </div>
    </div>
    <footerComponent />
</template>

<style lang="scss" scoped>
$gray_e4: #e4e4e3;
$gray_b1: #b1b0b0;
$gray_66: #666;
$gray_33: #333;

.container {
  .title-btn {
    margin: 3rem 0;
    #title {
      margin: 0;
      img {
        width: 3rem;
        height: 3rem;
      }
      p {
        color: $gray_33;
      }
    }
  }

  .usersetting {
    width: 90%;
    margin: 2rem auto;
    border: 1px solid;
    border-color: $gray_e4;
    border-radius: 10px;
    padding: 0 1rem 3rem;
    background-color: #ffffff;
    color: $gray_66;

    .sub-title {
      margin: 3rem 1rem  1rem;
      p {
        margin: 0;
      }
      .nochange {
        color: red;
      }
    }

    .with-sales-table{
      width: 40%;
    }

    .sales-table{
      width: 50%;
      font-size: small;
    }
    .sales-table-tr{
      width: 20%;
      padding: 1rem 0;
    }

    .infromation-table__th{
      color: $gray_33;
      border-top: 1px dotted;
      border-bottom: 1px dotted;
      border-color: $gray_e4;
      height: 100%;
      width: 30%;
      padding: 1rem;
    }
    .infromation-table__td{
      border-top: 1px dotted;
      border-bottom: 1px dotted;
      border-color: $gray_e4;
      padding: 1rem 0rem;
      color: $gray_66;
    }

    .table-data {
      padding: 0rem 1rem;
      border-left: 1px solid;
      border-color: $gray_b1;
    }
  }
}
.div__button{
  margin-top: 3rem;
}

.div__tableLeft{
  margin: 0.25rem auto;
}
.td__singlePrice{
  text-align: right;
  padding-right:0.5rem;
}

.aimodel_name--trainable{
  color: purple;
}


//=[AIモデル一覧テーブル]====================================================//
.aimodel_table {
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
  thead {text-align: center;}
  td {padding: 0.5rem 1rem;}
  tbody {text-align: center;}
  .td--aimodel-name{
  width: 100rem;
  text-align: left;
  }

}

.th--aimodel-name{width: 20%}
.th--language-pair{width: 6rem;}
.th--description{width: auto;}

.td--description{
  text-align: left;
}
.td--description__hidden{
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

//==========================================================================//
</style>


<script>
import { defineComponent } from "vue";
import menubar from "@/Pages/JVTA/menu_jvta.vue";
import footerComponent from "@/Pages/Components/footer.vue";
import { Link } from '@inertiajs/inertia-vue3'
export default defineComponent({
  components: { menubar, footerComponent, Link },
  props: {
    client: Object,
    numberOfClientModels: Number,
  },
  data() {
    return {
      showing_aimodel_description_ids: [],
    };
  },
  methods: {
    switchAimodelDescription(id){
      if (this.showing_aimodel_description_ids.includes(id)){
        this.showing_aimodel_description_ids.splice(this.showing_aimodel_description_ids.indexOf(id), 1);
      }else{
        this.showing_aimodel_description_ids.push(id);
      }
    },
    calcTotal(items) {
      return items.map(e => e.unit_price * e.quantity).reduce((a,b) => a + b, 0);
    },
    calcRequired(items) {
      return items.filter(e => !e.is_paid).map(e => e.unit_price * e.quantity).reduce((a,b) => a + b, 0);
    },
    OwnerUser(){
      const users = this.client?.users || [];
      return users.find(e => e.user_type && e.user_type.name === 'オーナー')
          || users.find(e => Number(e.user_type_id) === 1);
    },
    OwnerName(){
      const owner = this.OwnerUser();
      if(owner){
        return owner.name;
      }
      return "なし";
    },
    OwnerEmail(){
      const owner = this.OwnerUser();
      if(owner){
        return owner.email;
      }
      return "なし";
    }
  },
});
</script>
